import React from "react";
import { Modal, Box, Typography, IconButton,CircularProgress } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useState, useEffect } from 'react';

interface TutorialModalProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;       // can be string or JSX element
  videoLink?: string | null;
}

const TutorialModal: React.FC<TutorialModalProps> = ({
  open,
  onClose,
  title = "Tutorial",
  videoLink,
}) =>{
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    useEffect(() => {
        if (!open) setIsVideoLoaded(false);
    }, [open]);
  return (
  <Modal open={open} onClose={onClose} aria-labelledby="tutorial-modal">
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        width: { xs: "90%", sm: "75%" },
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: 2,
        p: 2,
      }}
      style={{ transform: "translate(-50%, -50%)", borderRadius: "10px" }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        {typeof title === "string" ? (
          <Typography variant="h6">{title}</Typography>
        ) : (
          title
        )}
        <IconButton size="small" onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>

      <Box
        sx={{
          position: "relative",
          paddingBottom: "56.25%",
          height: 0,
          overflow: "hidden",
        }}
      >
        {!isVideoLoaded && (
            <Box
              sx={{
                position: "absolute",
                top: "45%",
                left: "50%",
                textAlign: "center",
              }}
              style={{ transform: "translate(-50%, -50%)"}}
            >
              <CircularProgress size={32} />
              <Typography variant="body2">
                Loading tutorial...
              </Typography>
            </Box>
          )}
        {videoLink && (
          <iframe
             src={`${videoLink}`}
            title="Tutorial video"
            allow="autoplay; encrypted-media; fullscreen;"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        )}
      </Box>
    </Box>
  </Modal>
)};

export default TutorialModal;